const expansionPanelOverrides = {};

export { expansionPanelOverrides };
